import { useTranslations } from 'next-intl';

function formatDrawingTime(time?: string) {
  if (!time) {
    return '';
  }

  const [hourPart, minutePart = '0'] = time.split(':');
  const hour = Number(hourPart);
  const minute = Number(minutePart);
  const hour12 = hour % 12 || 12;
  const suffix = hour >= 12 ? 'pm' : 'am';

  return `${hour12}:${String(minute).padStart(2, '0')} ${suffix}`;
}

function PrizeAnnotations({ lotteryName, drawingDate, drawingTimes }: { lotteryName: string; drawingDate: string; drawingTimes: string[] }) {
  const t = useTranslations(`lotteries.${lotteryName}`);

  if (lotteryName === 'euroMillionsPlus') {
    return (
      <div data-testid="prize-tables-notes">
        <p className="paragraph-small text-foreground">
          {t('results_page_notes_1', {
            count: drawingTimes.length || 1,
            date: new Date(drawingDate),
            time: formatDrawingTime(drawingTimes[0]),
            secondTime: formatDrawingTime(drawingTimes[1]),
          })}
        </p>
        <p className="paragraph-small text-foreground">{t('results_page_notes_2')}</p>
      </div>
    );
  }

  return null;
}

export { PrizeAnnotations };
